export default "__VITE_ASSET__CGHUgaMG__"